import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../store/appStore';
import { Input } from '../components/ui/input';
import { SchoolCard } from '../components/Cards';

export default function SchoolsPage() {
  const { t, i18n } = useTranslation();
  const { schools, fetchSchools } = useAppStore();
  const [loading, setLoading] = useState(true);
  const [city, setCity] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      await fetchSchools(city ? { city } : {});
      setLoading(false);
    };
    load();
  }, [fetchSchools, city]);

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 animate-fade-in" data-testid="schools-page">
      <h1 className="font-serif text-4xl font-bold text-primary mb-8">{t('school.title')}</h1>
      
      <div className="mb-8">
        <Input placeholder={t('common.location')} value={city} onChange={(e) => setCity(e.target.value)} className="w-64" />
      </div>

      {loading ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.loading')}</p></div>
      ) : schools.length === 0 ? (
        <div className="text-center py-12"><p className="text-secondary">{t('common.noResults')}</p></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {schools.map((school) => (
            <SchoolCard key={school.id} school={school} language={i18n.language} />
          ))}
        </div>
      )}
    </div>
  );
}
